import { SESSION_STORAGE_KEYS } from '@/constant/storage'

import { getItem, removeItem, setItem } from './sessionStorageHelper'

interface NativeRegistration {
  email: string | null
  check: string | null
}

interface OauthRegistration {
  state: string | null
  codeVerifier: string | null
}

const setNativeRegistration = (invitationEmail: string, invitationChecksum: string): void => {
  setItem(SESSION_STORAGE_KEYS.EMAIL, invitationEmail)
  setItem(SESSION_STORAGE_KEYS.CHECK, invitationChecksum)
}

const getNativeRegistration = (): NativeRegistration => {
  return {
    email: getItem(SESSION_STORAGE_KEYS.EMAIL),
    check: getItem(SESSION_STORAGE_KEYS.CHECK)
  }
}

const removeNativeRegistration = (): void => {
  removeItem(SESSION_STORAGE_KEYS.EMAIL)
  removeItem(SESSION_STORAGE_KEYS.CHECK)
}

const setOauthRegistration = (oauthState: string, codeVerifier: string): void => {
  setItem(SESSION_STORAGE_KEYS.STATE, oauthState)
  setItem(SESSION_STORAGE_KEYS.CODE_VERIFIER, codeVerifier)
}

const getOauthRegistration = (): OauthRegistration => {
  return {
    state: getItem(SESSION_STORAGE_KEYS.STATE),
    codeVerifier: getItem(SESSION_STORAGE_KEYS.CODE_VERIFIER)
  }
}

const removeOauthRegistration = (): void => {
  removeItem(SESSION_STORAGE_KEYS.STATE)
  removeItem(SESSION_STORAGE_KEYS.CODE_VERIFIER)
}

const setPreviousRouteName = (routeName: string): void => {
  setItem(SESSION_STORAGE_KEYS.PREV_URL_ROUTE_NAME, routeName)
}

const getPreviousRouteName = (): string | null => {
  return getItem(SESSION_STORAGE_KEYS.PREV_URL_ROUTE_NAME)
}

const removePreviousRouteName = (): void => {
  removeItem(SESSION_STORAGE_KEYS.PREV_URL_ROUTE_NAME)
}

export {
  setNativeRegistration,
  getNativeRegistration,
  removeNativeRegistration,
  setOauthRegistration,
  getOauthRegistration,
  removeOauthRegistration,
  setPreviousRouteName,
  getPreviousRouteName,
  removePreviousRouteName
}

export type { NativeRegistration, OauthRegistration }
